module.exports = __webpack_public_path__ + "assets/rocket.46bd59a5.svg";